"use strict";

import '../styles/main.scss'; //Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
import 'babel-polyfill';
import * as menu from './client/plugin/menu';
import * as ads from './client/plugin/ads';
import * as wechat from './client/plugin/wechat';
import * as gallery from './client/plugin/gallery';
import * as engage from './client/plugin/engage';

$( () => {
	menu.init();
	ads.init();
	wechat.init();
	gallery.init();
	engage.init();
});


// WEBPACK FOOTER //
// ./src/scripts/main.js